export const SERVER_URL = "https://server.aps-benin.com"
export const SIMULATION_FRONTEND_URL = "https://simulation.aps-benin.com"
export const MEMBERS_FRONTEND_URL = "https://app.aps-benin.com"



// WEBPACK FOOTER //
// ./src/utils/helpers/constanteData.js